export const cumulativeStdNormalProbability = (z: number): number => {
  // Approximation of the cumulative standard normal distribution function
  // Using the error function approximation
  const a1 =  0.254829592
  const a2 = -0.284496736
  const a3 =  1.421413741
  const a4 = -1.453152027
  const a5 =  1.061405429
  const p  =  0.3275911

  const sign = z < 0 ? -1 : 1
  const x = Math.abs(z) / Math.sqrt(2)

  // A&S formula 7.1.26
  const t = 1.0 / (1.0 + p * x)
  const y = 1.0 - (((((a5 * t + a4) * t) + a3) * t + a2) * t + a1) * t * Math.exp(-x * x)

  return 0.5 * (1.0 + sign * y)
}

const calculateConversionRate = (
  conversions: number,
  totalVisitors: number
): number => {
  if (totalVisitors === 0) return 0
  return (conversions / totalVisitors) * 100
}

/** Safe divide that never returns NaN/Infinity (0/0, n/0, non-finite inputs). */
export const safeRatio = (
  numerator: number,
  denominator: number,
  fallback = 0
): number => {
  if (!denominator || !Number.isFinite(numerator) || !Number.isFinite(denominator)) {
    return fallback
  }
  const result = numerator / denominator
  return Number.isFinite(result) ? result : fallback
}

const calculateConfidenceInterval = (
  rate: number,
  sampleSize: number,
  confidenceLevel: number = 0.95
): { lower: number; upper: number } => {
  if (sampleSize === 0) return { lower: 0, upper: 0 }
  
  const z = confidenceLevel === 0.95 ? 1.96 : 2.58 // 95% or 99%
  const standardError = Math.sqrt((rate * (1 - rate)) / sampleSize)
  const margin = z * standardError
  
  return {
    lower: Math.max(0, rate - margin),
    upper: Math.min(1, rate + margin)
  }
}
